<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Statistics Finland: Open Days') }}</h4>
    </div>
    <div class="modal-body">
      <h4>{{ _('Select year') }}</h4>
      <select v-model="year" class="form-control">
        <option v-for="year in selectableYears" :value="year" :key="year">{{ year }}</option>
      </select>
      <br/>
      <div v-if="year">
        <p v-if="!selectedYear.id">{{ _('Data prefilled using data from the previous year. Please make necessary changes and save.') }}</p>
        <div class="form-group">
          <label for="january">{{ _('January') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.january" id="january" />
        </div>
        <div class="form-group">
          <label for="february">{{ _('February') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.february" id="february" />
        </div>
        <div class="form-group">
          <label for="march">{{ _('March') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.march" id="march" />
        </div>
        <div class="form-group">
          <label for="april">{{ _('April') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.april" id="april" />
        </div>
        <div class="form-group">
          <label for="may">{{ _('May') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.may" id="may" />
        </div>
        <div class="form-group">
          <label for="june">{{ _('June') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.june" id="june" />
        </div>
        <div class="form-group">
          <label for="july">{{ _('July') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.july" id="july" />
        </div>
        <div class="form-group">
          <label for="august">{{ _('August') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.august" id="august" />
        </div>
        <div class="form-group">
          <label for="september">{{ _('September') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.september" id="september" />
        </div>
        <div class="form-group">
          <label for="october">{{ _('October') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.october" id="october" />
        </div>
        <div class="form-group">
          <label for="november">{{ _('November') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.november" id="november" />
        </div>
        <div class="form-group">
          <label for="december">{{ _('December') }}</label>
          <input class="form-control" type="number" data-android-inputmode="decimal" v-model="selectedYear.december" id="december" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="save"><i class="fas fa-save"></i> {{ _('Save') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['opendays'],
  data () {
    return {
      year: undefined
    }
  },
  computed: {
    selectableYears () {
      const now = new Date().getFullYear()
      let years = []
      this.opendays.forEach(year => {
        years.push(year.year)
      })
      if (!years.find(y => parseInt(y) === parseInt(now - 1))) {
        years.push(now - 1)
      }
      if (!years.find(y => parseInt(y) === parseInt(now))) {
        years.push(now)
      }
      if (!years.find(y => parseInt(y) === parseInt(now + 1))) {
        years.push(now + 1)
      }
      years = years.sort((a, b) => a > b ? 1 : -1)
      return years
    },
    selectedYear: {
      get () {
        return this.opendays.find(y => parseInt(y.year) === parseInt(this.year))
      },
      set (newValue) {
        let y = this.opendays.find(y => parseInt(y.year) === parseInt(this.year))
        return y = newValue
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save () {
      this.$emit('setStatisticsFinlandOpenDays', this.opendays)
    }
  },
  mounted () {
    let currentYear = new Date().getFullYear()
    let prevYearData
    this.selectableYears.forEach(year => {
      if (!this.opendays.find(y => parseInt(y.year) === parseInt(year))) {
        if (prevYearData = this.opendays.find(y => parseInt(y.year) === parseInt(year) - 1)) {
          let { id, ...autoFilledData } = prevYearData
          autoFilledData.year = year
          this.opendays.push(autoFilledData)
        } else {
          this.opendays.push({
            year: year,
            january: 0,
            february: 0,
            march: 0,
            april: 0,
            may: 0,
            june: 0,
            july: 0,
            august: 0,
            september: 0,
            october: 0,
            november: 0,
            december: 0
          })
        }
      }
    })
    this.year = currentYear
  }
}
</script>